import { ReactComponent as PlainGlazeButton } from './plain_glaze_button.svg'
import { ReactComponent as ChocolateGlazeButton } from './chocolate_glaze_button.svg'
import { ReactComponent as StrawberryGlazeButton } from './strawberry_glaze_button.svg'
import { ReactComponent as MapleGlazeButton } from './maple_glaze_button.svg'
import { ReactComponent as BlueberryGlazeButton } from './blueberry_glaze_button.svg'
import { ReactComponent as PistachioGlazeButton } from './pistachio_glaze_button.svg'

const DonutGlazingButtons = {
  PlainGlazeButton,
  ChocolateGlazeButton,
  StrawberryGlazeButton,
  MapleGlazeButton,
  BlueberryGlazeButton,
  PistachioGlazeButton,
}

export default DonutGlazingButtons
